module.exports = __webpack_public_path__ + "img/pay-back.d8a5b68.png";